export default __webpack_public_path__ + "static/sizzle_mobile-7afcd99c054094e4141b073fa863e9d3.mp4";